import type { RouteRecordRaw } from 'vue-router'

export const useMuseRoutes = (): RouteRecordRaw[] => [
  // 用户侧
  {
    path: '/user/muse/dashboard',
    name: 'MuseHome',
    component: () => import('../views/user/Home.vue'),
  },
  {
    path: '/user/muse/voiceTemplate',
    name: 'MuseVoiceTemplate',
    component: () => import('../views/user/VoiceTemplate.vue'),
  },
  {
    path: '/user/muse/voice',
    name: 'MuseVoiceSynth',
    component: () => import('../views/user/Voice.vue'),
  },
  {
    path: '/user/muse/avatar',
    name: 'MuseAvatar',
    component: () => import('../views/user/Avatar.vue'),
  },
  {
    path: '/user/muse/avatarGenerate',
    name: 'MuseAvatarGenerate',
    component: () => import('../views/user/AvatarGenerate.vue'),
  },
  // 管理侧
  {
    path: '/muse/dashboard',
    name: 'MuseAdminDashboard',
    component: () => import('../views/Dashboard.vue'),
  },
  {
    path: '/muse/avatarPreset',
    name: 'MuseAdminAvatarPreset',
    component: () => import('../views/AvatarPreset.vue'),
  },
  {
    path: '/muse/task',
    name: 'MuseAdminTask',
    component: () => import('../views/TaskList.vue'),
  },
  {
    path: '/muse/modelConfig',
    name: 'MuseAdminModelConfig',
    component: () => import('../views/ModelConfig.vue'),
  },
  {
    path: '/muse/pricing',
    name: 'MuseAdminPricing',
    component: () => import('../views/Pricing.vue'),
  },
  {
    path: '/muse/setting',
    redirect: '/muse/setting/basic',
  },
  {
    path: '/muse/setting/:tab',
    name: 'MuseSetting',
    component: () => import('../../../base/src/views/Setting/SettingView.vue'),
  },
]
